import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';

import AuthBackground from 'components/AuthBackground';
import { verify as TEXT } from 'locales/en/signUp';
import emailURL from 'utils/emailURL';

const Verify = ({ onClickReturn }) => {
  const user = useSelector((state) => state.auth.user);
  const emailLink = useMemo(() => emailURL(user.email), [user.email]);

  return (
    <AuthBackground
      header1={TEXT.header1}
      header2={TEXT.adminHeader2(user.email)}
    >
      {emailLink ? (
        <a
          href={emailLink}
          target="_blank"
          rel="noreferrer"
          className="btn bg-javelin-blue-dark w-44 py-4 font-bold text-base rounded-full mt-2 px-4 text-center"
        >
          {TEXT.goToEmail}
        </a>
      ) : (
        <p
          onClick={onClickReturn}
          className="text-sm text-javelin-blue-dark border-0 text-left focus:outline-none cursor-pointer"
        >
          {TEXT.return}
        </p>
      )}
    </AuthBackground>
  );
};

export default Verify;
